// type Environment = "development" | "production";

// const endpoints: Record<Environment, string> = {
//   development: "https://eigen-development.fly.dev",
//   production: "https://eigen-production.fly.dev",
// };
// console.log(
//   "import.meta.env.VITE_ENVIRONMENT",
//   import.meta.env.VITE_ENVIRONMENT
// );
export const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT;

// export const POCKETBASE_BASE_ENDPOINT = endpoints[ENVIRONMENT];
export const POCKETBASE_BASE_ENDPOINT = import.meta.env.VITE_POCKETBASE_ENDPOINT;

export const USE_SENTRY = (import.meta.env.VITE_USE_SENTRY ?? "0") === "1";

export const BACKEND_URL = import.meta.env.VITE_BACKEND_URL || "http://localhost:3000";
//TODO: We can get all allowed origins of PaaS clients from the database api key collection.
const DEFAULT_POSTMESSAGE_ORIGINS = "*" // "http://localhost:3000,http://localhost:3001,https://app-principal.cl";

export const POSTMESSAGE_ALLOWED_ORIGINS: string[] = import.meta.env.VITE_POSTMESSAGE_ALLOWED_ORIGINS
  ? import.meta.env.VITE_POSTMESSAGE_ALLOWED_ORIGINS.split(",").map((s) => s.trim()).filter(Boolean)
  : DEFAULT_POSTMESSAGE_ORIGINS.split(",").map((s) => s.trim());

const DEFAULT_AUTH_REFRESH_MARGIN_MS = 30 * 1000;
export const AUTH_REFRESH_MARGIN_MS = import.meta.env.VITE_AUTH_REFRESH_MARGIN_MS
  ? parseInt(import.meta.env.VITE_AUTH_REFRESH_MARGIN_MS, 10)
  : DEFAULT_AUTH_REFRESH_MARGIN_MS;

export const AUTH_EMBED_MODE_KEY =
  import.meta.env.VITE_AUTH_EMBED_MODE_KEY ?? "eigen_embed_mode";

console.log("GIT_HASH", __GIT_HASH__);

console.log("POCKETBASE_BASE_ENDPOINT", POCKETBASE_BASE_ENDPOINT);
